<nv-icon-button
  *ngIf="showTrash"
  name="trash-small-blue"
  (clickButton)="onStatusChange()"
  [disabled]="isViewOnlyUser"
></nv-icon-button>
